module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Visa profil":"Show profile","Markera som oläst":"Mark as unread","Markera som läst":"Mark as read"},"sv":{"Visa profil":"Visa profil","Markera som oläst":"Markera som oläst","Markera som läst":"Markera som läst"}}')
  delete Component.options._Ctor
}
